/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
//import VueToast from "vue-toast-notification"
import Multiselect from "vue-multiselect"
import { ClientTable } from "vue-tables-2"
import Dayjs from "vue-dayjs"
import moment from "moment"
import "./registerServiceWorker"
import "./vee-validate"
import ArgonDashboard from "./plugins/argon-dashboard"
import BootstrapModalCompat from "./plugins/bootstrapModal"
import store from "./store/store"
import ToggleButton from "vue-js-toggle-button"
import Vuetify from "vuetify"
import "vuetify/dist/vuetify.min.css"

import DefaultButton from "@/components/DefaultButton"
import DefaultModal from "@/components/Modals/DefaultModal"
import VueJsonToCsv from "vue-json-to-csv"
import Toast, { useToast } from "vue-toastification"
import "vue-toastification/dist/index.css"
import ToastMessage from "@/components/ToastMessage"
import { VueReCaptcha } from "vue-recaptcha-v3"
import vue3GoogleLogin from "vue3-google-login"
import TextInput from "@/components/MaterialDesign/TextInput"
import RadioInput from "@/components/RadioInput"
import GfbPasswordInput from "@/components/GfbPasswordInput"
import GfbRadioGroup from "@/components/GfbRadioGroup"
import GfbCheckboxGroup from "@/components/GfbCheckboxGroup"
import GfbFormContainer from "@/components/GfbFormContainer"
import LoginFooter from "@/components/LoginFooter"
import Vue2Editor from "vue2-editor"

import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue-next/dist/bootstrap-vue-next.css"
import { captureUtmParams } from "@/utils/utmParams"

// Capture any utm_* marketing params off the landing URL before the app
// (and router) start rewriting the address bar (GFB-1380).
captureUtmParams()

const app = createApp(App)
const vuetify = new Vuetify({
  icons: {
    iconfont: "mdi", // Specify MDI icons
  },
})

app.use(Vue2Editor)

app.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  loaderOptions: { autoHideBadge: true },
})

app.use(vue3GoogleLogin, {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
})

app.use(Toast, {
  position: "top-right",
  duration: 6000,
  hideProgressBar: true,
})
app.config.globalProperties.$toast = useToast()

app.use(vuetify)

let vueTablesOptions = {
  theme: "bootstrap4",
  sortIcon: {
    base: "ml-2 fas",
    up: "fa-sort-up",
    down: "fa-sort-down",
    is: "fa-sort",
  },
  skin: "table app-table",
  pagination: {
    nav: "scroll",
  },
}
app.config.globalProperties.moment = moment
app.component("multiselect", Multiselect)
app.use(ClientTable, vueTablesOptions)
app.use(Dayjs)
app.use(ArgonDashboard)
app.use(BootstrapModalCompat)
app.use(ToggleButton)
app.component("default-button", DefaultButton)
app.component("text-input", TextInput)
app.component("radio-input", RadioInput)
app.component("vue-json-to-csv", VueJsonToCsv)
app.component("default-modal", DefaultModal)
app.component("toast-message", ToastMessage)
app.component("login-footer", LoginFooter)
app.component("gfb-password-input", GfbPasswordInput)
app.component("gfb-radio-group", GfbRadioGroup)
app.component("gfb-checkbox-group", GfbCheckboxGroup)
app.component("gfb-form-container", GfbFormContainer)
app.use(router)
app.use(store)
app.mount("#app")

console.log("API URL: " + process.env.VUE_APP_API_URL)
